exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(min-width:768px){.facebook-login[data-v-7dc0d3a6]{min-width:54px}}.facebook-login button[data-v-7dc0d3a6]{width:54px!important;height:54px!important;background:transparent!important}.size[data-v-7dc0d3a6]{min-width:calc(100% - 60px)!important}.auth__in[data-v-7dc0d3a6]{position:relative}", ""]);

// exports
